import styled from 'styled-components';

export const LoadingSpinnerContainer = styled.div`
    display: flex;
    align-items: center;

    span {
        margin-left: 0.8rem;
    }
`;
